var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{class:{'container--tablet': this.$vuetify.breakpoint.md},scopedSlots:_vm._u([{key:"component",fn:function(){return [_c('v-col',{staticClass:"container__col"},[_c('SettingsInfo')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }